interface CheckCircleIconProps {
  className?: string;
}

/**
 * Filled circle with a knocked-out check. Paired with {@link EmptyCircleIcon},
 * the two read apart by shape as well as colour, so status never depends on
 * colour alone.
 */
export const CheckCircleIcon = ({ className = 'h-3 w-3' }: CheckCircleIconProps) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.793a1 1 0 00-1.414-1.414L9 10.086 7.707 8.793a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      clipRule="evenodd"
    />
  </svg>
);
